var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{class:`icon iconfont icon-${_vm.name}`})
}
var staticRenderFns = []

export { render, staticRenderFns }